import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useMemo } from 'react';
import { BasicMantineTable } from '@dealstack/frontend/shared/components/BasicMantineTable/BasicMantineTable';
import { getKycFormsTableColumns } from './kycFormsTableColumns';
import type { FormPair } from './types';

interface Props {
	data: FormPair[];
	onDelete: (formId: string) => void;
	onPreview: (formPair: FormPair) => void;
	onSign: (formPair: FormPair) => void;
	onInstructionClick: (formDefinitionId: string) => void;
	onStartSigning: (formPair: FormPair) => void;
}

export const InvestorKycFormsTable = ({
	data,
	onDelete,
	onPreview,
	onSign,
	onInstructionClick,
	onStartSigning,
}: Props) => {
	const tInvestor = useTranslationInvestor();

	const columns = useMemo(
		() =>
			getKycFormsTableColumns({
				tInvestor,
				onDelete,
				onPreview,
				onSign,
				onInstructionClick,
				onStartSigning,
			}),
		[tInvestor, onDelete, onPreview, onSign, onInstructionClick, onStartSigning]
	);

	return (
		<BasicMantineTable<FormPair>
			columns={columns}
			data={data}
			hideTopToolbar
			mantineTableBodyRowProps={() => ({
				style: {
					height: 'unset',
				},
			})}
		/>
	);
};
